import translate from 'libs/translate'

export function getStartingPosition(language) {
    const startingPoints = {
        'nl': { lat: 52.374004, lng: 4.890359, zoom: 14 }, // Amsterdam
        'fr': { lat: 48.8586125, lng: 2.3363782, zoom: 13 }, // Paris
        'be': { lat: 50.85034, lng: 4.35171, zoom: 10 },   // Brussels
        'de': { lat: 52.519171, lng: 13.406091, zoom: 12 } // Berlin
    }

    return startingPoints[language] || startingPoints['nl']
}

const getDefaultOptions = (maps, language) => {
    const startingPoint = getStartingPosition(language)

    return {
        center: { lat: startingPoint.lat, lng: startingPoint.lng },
        zoom: startingPoint.zoom,
        mapTypeId: maps.MapTypeId.ROADMAP,
        panControl: false,
        scaleControl: false,
        rotateControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        mapTypeControl: false,
        scrollwheel: true,
        zoomControl: true,
        gestureHandling: 'greedy',
        zoomControlOptions: {
            style: maps.ZoomControlStyle.LARGE,
            position: maps.ControlPosition.TOP_RIGHT
        }
    }
}


export const connectorNames = {
    'TepcoCHAdeMO': 'CHAdeMO',
    'Type2': 'Type 2 Mennekes',
    'Type3': 'Type 3 Le Grand',
    'Type1': 'Type 1 Yazaki',
    'Type2Combo': 'Combo',
    'Domestic': () => translate('landing_filter_connector_domestic')
}

export const powers = [3.3, 7.4, 10, 22, 43, 50]

export const defaultMarkerFilter = {
    showOnlyAvailable: false,
    onlyAccessibleWithCard: false,
    minPower: powers[0],
    connectors: ['TepcoCHAdeMO', 'Type2', 'Type3', 'Type1', 'Type2Combo', 'Domestic']
}

export default getDefaultOptions
